// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__1-9Xh","active":"Uploader_active__lHKZ0"};